var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1127_1092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 7.99998H14.6667M1.33337 7.99998C1.33337 11.6819 4.31814 14.6666 8.00004 14.6666M1.33337 7.99998C1.33337 4.31808 4.31814 1.33331 8.00004 1.33331M14.6667 7.99998C14.6667 11.6819 11.6819 14.6666 8.00004 14.6666M14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8.00004 1.33331M8.00004 1.33331C9.66756 3.15888 10.6152 5.528 10.6667 7.99998C10.6152 10.472 9.66756 12.8411 8.00004 14.6666M8.00004 1.33331C6.33252 3.15888 5.38487 5.528 5.33337 7.99998C5.38487 10.472 6.33252 12.8411 8.00004 14.6666",
    stroke: "#CAD5E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1127_1092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobe);
export default __webpack_public_path__ + "static/media/ic_globe.7d511c6b5d7a3241e2f10dcca29451e3.svg";
export { ForwardRef as ReactComponent };